// extracted by mini-css-extract-plugin
export var chip = "_5o-0";
export var filterDropdown = "_5o-5";
export var filterItem = "_5o-6";
export var icon = "_5o-1";
export var removeButton = "_5o-3";
export var removeIcon = "_5o-4";
export var separator = "_5o-2";